﻿import { getUserData } from '../../auth/views/login/auth.api.js';

const baseUrl = 'https://dashboard.pressuretrack.co.za/api';

const { parentCustomerId } = getUserData() || {};

export const fetchCustomers = async () => {
  try {
    const { token } = getUserData() || {};
    const apiUrl = `${baseUrl}/customer`;
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      }
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    return data.count ? data.results : [];

  } catch (e) {
    console.error('customersJS: fetchCustomers - ERROR ', e);
  }
};

// GET /customer/{customerId} — one customer with its address and contact details.
// Resolves the customer object, or null on any failure (401 / 404 / network).
export const fetchCustomer = async (customerId) => {
  if (customerId === null || customerId === undefined || customerId === '') return null;
  try {
    const { token } = getUserData() || {};
    const apiUrl = `${baseUrl}/customer/${encodeURIComponent(customerId)}`;
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      }
    });

    if (!response.ok) {
      throw new Error(`Network response was not ok (${response.status})`);
    }

    const data = await response.json();
    return data && typeof data === 'object' ? data : null;

  } catch (e) {
    console.error('customersJS: fetchCustomer - ERROR ', e);
    return null;
  }
};

// export const getUsers = async() => {
//     try {
//         const { token } = getUserData() || {};
//         const apiUrl = `${baseUrl}/customer/${parentCustomerId}/user`;
//         const response = await fetch(apiUrl, {
//             method: 'GET',
//             headers: {
//                 'Authorization': `Bearer ${token}`,
//                 'Accept': 'application/json',
//             }
//         });

//         if (!response.ok) {
//             throw new Error('Network response was not ok');
//         }

//         const data = await response.json();
//         return data.count ? data.results : [];

//     } catch (e) {
//         console.error('getunitdataJS: fetchUnits - ERROR ', e);
//     }
// }

export const getUsers = async (options = {}) => {
  const { token, parentCustomerId } = getUserData() || {};

  const pathCustomerId = options.pathCustomerId || global.customerId || parentCustomerId;

  const params = new URLSearchParams({
    sort: options.sort || 'name',
    inclChild: String(options.inclChild ?? true),
    limit: String(options.limit ?? 0),
    offset: String(options.offset ?? 0),
  });

  if (options.customerId) {
    params.set('customerId', options.customerId);
  }

  const apiUrl = `${baseUrl}/customer/${pathCustomerId}/user?${params.toString()}`;

  const response = await fetch(apiUrl, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
    },
    credentials: 'include',
  });

  if (!response.ok) {
    const errorDetails = await response.json().catch(() => null);
    console.error('Error fetching users:', errorDetails || response.statusText);
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return data.count ? data.results : [];
};

export async function addUser(user) {
  try {
    const { token } = getUserData() || {};
    const apiUrl = `${baseUrl}/customer/${parentCustomerId}/user`;
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify(user)
    });

    const responseData = await response.json();

    if (response.ok) {
      console.log("Success:", responseData.message);
    } else {
      console.error("Error:", responseData);
    }

  } catch (e) {
    console.error("Error updating user:", e);
  }
}

export async function editUser(userId, updatedUser) {
  try {
    const { token } = getUserData() || {};

    const apiUrl = `${baseUrl}/customer/${parentCustomerId}/user/${userId}`;

    const response = await fetch(apiUrl, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify(updatedUser)
    });

    const responseData = await response.json();

    if (response.ok) {
      console.log("Success:", responseData.message);
    } else {
      console.error("Error:", responseData);
    }

  } catch (e) {
    console.error("Error updating user:", e);
  }
}

export async function deleteUser(userId) {
  try {

    const { token } = getUserData() || {};
    const apiUrl = `${baseUrl}/customer/${parentCustomerId}/user/${userId}`;

    const response = await fetch(apiUrl, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      }
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Bad network response: ${response.status} - ${errorText}`);
    }
  } catch (e) {
    console.error('userdataJS: deleteUser - ERROR', e);
    throw e;  // Re-throw the error for higher-level handling if necessary
  }
}